import React, { useState } from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import moment from 'moment';
import DeleteIcon from '@material-ui/icons/Delete';
import ContributionCRU from './ContributionCRU';
import { checkPermission } from '../../../../utils_v2';
import { AttachmentsRow } from '../../components';
import { titanInstance } from '../../../../shared_elements/components';

export default function ContributionList({item, previewDetail, getResponseBack, contractInfo,deletecontibution}){
  const [showMore, setShowMore] = useState({});
  const toggleDescription = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };
  return(
    <>
    <TableRow hover >
      <TableCell>{item?.component||'--'}</TableCell>
      <TableCell>{item?.party||'--'}</TableCell>
      {!titanInstance?<><TableCell>{item?.type||'--'}</TableCell>
      <TableCell>{item?.completed||'--'}</TableCell></>:null}
      <TableCell style={{maxWidth:'400px'}}>
      {item?.description && item?.description?.length > 200 ? (
          <div style={{ maxWidth: '400px' }}>
            {showMore[item?.id] && showMore[item?.id] ? (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.description.replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id); }} >
                  less
                </a>
              </span>
            ) : (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.description.substring(0, 190).replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id); }} >
                  ..more
                </a>
              </span>
            )}
          </div>
        ) : (
          <div>
                {item?.description ? <span dangerouslySetInnerHTML={{ __html: item?.description.replace(/\n/g, '<br />') }} />:'--'}
          </div>
        )}
        </TableCell> 
        <TableCell>{item?.attachments?.length> 0 ?<AttachmentsRow attachmentsData={item?.attachments}/>:"--"}</TableCell>  
      <TableCell>
        <ContributionCRU getResponseBack={getResponseBack} m="V" id={item?.id} contractInfo={contractInfo}/>
        {checkPermission('contracts','contribution', 'D')?<DeleteIcon fontSize='small' color='secondary' style= {{cursor:'pointer'}} onClick={()=>deletecontibution(item?.id)}/>:null}
      </TableCell>
      </TableRow>
    </>
  )
}
